export default __webpack_public_path__ + "static/media/package.0292959b.png";